import { ChangeEvent } from 'react'
import { useForm, FormProvider } from 'react-hook-form'

import ContextTest from './ContextTest'
import { TestFormType } from './types'
import useTest from './useTest'

const TestComponent = () => {
	const { methods, handleCompressImage, compressedFileWatch } = useTest()

	const onSubmit = (data: TestFormType) => {
		console.log(data)
	}

	return (
		<div>
			<FormProvider {...methods}>
				<form onSubmit={methods.handleSubmit(onSubmit)}>
					<ContextTest
						handleCompressImage={handleCompressImage}
						compressedFile={compressedFileWatch}
					/>
					<input type="submit" value="Submit" />
				</form>
			</FormProvider>
		</div>
	)
}

export default TestComponent
